import React from "react";
import { Container, Left, Right } from "./styles";
import Card from "components/card";
import useWindowSize from "hooks/windowSize";

const Layout = ({ children }) => {
  const [width] = useWindowSize();
  const device = width <= 1366 ? "mobile" : "desktop";
  return (
    <Container>
      <Left src={require(`assets/images/auth-image-${device}.svg`)} />
      <Right>
        <Card>{children}</Card>
      </Right>
    </Container>
  );
};

export default Layout;
